module.exports = __webpack_public_path__ + "static/KotoriRose-Bold-308e44c2cbe90e8cfcaef0a8998d2449.otf";